
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"179","height":"261","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M119.912 65.24L179 0h-60.861L89.5 31.636 60.861 0H0l59.088 65.24L0 130.481l59.088 65.241L0 261h60.861L89.5 229.364 118.139 261H179l-59.088-65.241L179 130.519l-59.088-65.24v-.038zM89.5 162.156l-28.639-31.636L89.5 98.883l28.639 31.636L89.5 162.155z","fill":"#F2F2F2"}})])
          )
        }
      }
    